import { render, staticRenderFns } from "./QuestionBankArchives.vue?vue&type=template&id=6c39eafa&scoped=true"
import script from "./QuestionBankArchives.vue?vue&type=script&lang=js"
export * from "./QuestionBankArchives.vue?vue&type=script&lang=js"
import style0 from "./QuestionBankArchives.vue?vue&type=style&index=0&id=6c39eafa&prod&lang=css"
import style1 from "./QuestionBankArchives.vue?vue&type=style&index=1&id=6c39eafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c39eafa",
  null
  
)

export default component.exports